import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import Refund from "./Refund";

const GifticonRefundBox = ({ handleClickBack, handleClickX, paymentId }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [reason, setReason] = useState("");
  const [selectedItemId, setSelectedItemId] = useState([]);
  const [order_item_list, setOrder_item_list] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  const [total_order, setTotal_order] = useState(0);

  const [clickRefundInput, setClickRefundInput] = useState(false);

  const [isButtonEnabled, setIsButtonEnabled] = useState(
    reason && selectedItemId.length > 0
  );

  const getOrderDetail = async () => {
    try {
      const body = { page, offset, paymentId };
      const res = await postJson("/dashboard/gifticonOrder/getDetail", body, navigate);

      if (res.code === 200) {
        setTotal_order(res.data.count);
        setOrderInfo(res.data.orderInfo);
        setOrder_item_list(res.data.rows);
      }
    } catch (error) {
      console.error("주문 상세 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    setIsButtonEnabled(reason && selectedItemId.length > 0);
  }, [reason, selectedItemId]);

  // 컴포넌트 렌더링 시 getDetail
  useEffect(() => {
    getOrderDetail();
  }, []);

  // 최초 호출에서 총갯수가 바뀌면 offset설정
  useEffect(() => {
    if (total_order > 0) {
      setOffset(total_order);
    }
  }, [total_order]);

  // offset이 바뀌면 다시 getDetail
  useEffect(() => {
    if (offset > 0) {
      getOrderDetail();
    }
  }, [offset]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const validItemIds = order_item_list
        // 환불상태가 정상인 경우만 추가
        .filter((item) => item.refundStatus === "정상")
        .map((item) => item.orderItemId);
      setSelectedItemId(validItemIds);
    } else {
      setSelectedItemId([]);
    }
  };

  const handleSelectItem = (id, refundStatus) => {
    if (refundStatus !== "정상") return; // 환불상태가 정상이 아니면 리턴
    setSelectedItemId((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((itemId) => itemId !== id) // 이미 선택된 경우 해제함
        : [...prevSelected, id]
    );
  };

  return (
    <Box>
      {clickRefundInput && (
        <Refund
          handleClickX={() => setClickRefundInput(false)}
          paymentId={orderInfo.paymentId}
          reason={reason}
          orderItemIdArr={selectedItemId}
        />
      )}
      <div className="hrz-wrapper">
        <RightBracket
          stroke="#b0b0b0"
          width="32px"
          height="32px"
          style={{ transform: "rotate(180deg)", cursor: "pointer" }}
          onClick={handleClickBack}
        />
        <p className="bold-text" style={{ fontSize: "24px" }}>
          환불요청
        </p>
        <IconCrossRound
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleClickX}
        />
      </div>

      <p className="medium-text" style={{ marginTop: "20px" }}>
        환불하실 상품을 선택해주세요
      </p>
      <div className="scrollView" style={{ height: "288px" }}>
        <div
          className="list_titleBar"
          style={{
            width: "825px",
            gridTemplateColumns: "50px 300px 140px 335px",
            marginTop: "10px",
          }}
        >
          <div className="center">
            <input
              type="checkbox"
              style={{ width: "20px", height: "20px" }}
              onChange={handleSelectAll}
              checked={
                selectedItemId.length ===
                  order_item_list.filter((item) => item.refundStatus === "정상")
                    .length &&
                order_item_list.filter((item) => item.refundStatus === "정상")
                  .length > 0
              }
            />
          </div>
          <p className="leftalign">상품명</p>
          <p className="leftalign">주문 수량</p>
          <p className="leftalign">주문 금액</p>
        </div>
        {order_item_list.map((data) => (
          <div
            key={data.orderItemId}
            className="list_contentBar"
            style={{
              width: "825px",
              gridTemplateColumns: "50px 300px 140px 335px",
            }}
          >
            <div className="center">
              {data.refundStatus === "정상" ? (
                <input
                  type="checkbox"
                  style={{ width: "20px", height: "20px" }}
                  onChange={() =>
                    handleSelectItem(data.orderItemId, data.refundStatus)
                  }
                  checked={selectedItemId.includes(data.orderItemId)}
                  disabled={data.refundStatus !== "정상"}
                />
              ) : (
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "4px",
                    backgroundColor: "#e4e4e4",
                    boxShadow: "inset 0 0 0 1.5px #b0b0b0",
                  }}
                ></div>
              )}
            </div>
            <p className="leftalign">{data.goodsName}</p>
            <p className="leftalign">{data.quantity?.toLocaleString()}개</p>
            <p className="leftalign">{data.totalAmount?.toLocaleString()}원</p>
          </div>
        ))}
      </div>

      <p className="medium-text" style={{ marginTop: "20px" }}>
        환불 사유*
      </p>
      <div
        style={{
          padding: "16px 14px",
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          borderRadius: "10px",
          marginTop: "14px",
        }}
      >
        <input
          type="text"
          className="textinput"
          style={{ width: "703px", height: "21px" }}
          placeholder="환불 사유를 5글자 이상 입력해주세요."
          onChange={(e) => setReason(e.target.value)}
        />
      </div>

      <p style={{ marginTop: "20px", fontSize: "14px", color: "#888888" }}>
        · 환불요청 이후 요청을 취소할 수 없습니다.
        <br />
        · 주문한 수량중 1개 이상의 상품을 소진(발급)되었을 경우 환불요청이
        불가능합니다.
        <br />
        · 우리기업 챌린지에 등록되어있는 상품은 환불요청이 불가능합니다. 등록을
        해제하고 다시 시도해주세요.
        <br />
        · 이미 해당 항목에 대해 환불이 처리중이거나 처리완료된 경우 환불요청이
        불가능합니다.
        <br />
        · 환불 금액은 5 영업일 이내에 환불 계좌로 입금됩니다.
        <br />
      </p>

      <div
        className="blueBtn-base"
        style={{
          width: "400px",
          height: "60px",
          borderRadius: "10px",
          backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
          marginTop: "20px",
          justifySelf: "center",
        }}
        onClick={isButtonEnabled ? () => setClickRefundInput(true) : null}
      >
        환불 정보 입력
      </div>
    </Box>
  );
};

const GifticonRefund = ({ handleClickBack, handleClickX, paymentId }) => {
  return (
    <LayoutModal
      Modal={
        <GifticonRefundBox
          handleClickBack={handleClickBack}
          handleClickX={handleClickX}
          paymentId={paymentId}
        />
      }
    />
  );
};

const Box = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default GifticonRefundBox;
